import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss'
})
export class SplashComponent implements OnInit {

  currentScreen: string = 'splash1';
  shutterAnimating: boolean = false;
  showPrivacyPolicy: boolean = false;

  ngOnInit() {
    // First transition with a slight overlap to avoid white flashes
    setTimeout(() => this.currentScreen = 'splash2', 1800);  // Slightly earlier than before
    
    // Second transition with similar overlap
    setTimeout(() => {
      this.currentScreen = 'login';     // Change to login screen before shutter animation
      // Small delay before starting shutter animation to ensure screen is loaded
      setTimeout(() => this.shutterAnimating = true, 50);
    }, 4800);    // Slightly earlier than before
  }

  // goToLogin() {
  //   this.router.navigate(['/login']);
  // }

  openPrivacyModal(){
    this.showPrivacyPolicy = true;
  }

  closePrivacyModal(){
    this.showPrivacyPolicy = false;
  }
}